import { dailyMessageData, messageStatusData } from "@/mocks/dashboard";

export default function MiniCharts() {
  const maxVal = Math.max(...dailyMessageData.map((d) => d.sayi));
  const totalStatus = messageStatusData.reduce((a, b) => a + b.value, 0);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Bar chart */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5">
        <div className="flex items-center justify-between mb-5">
          <div>
            <h3 className="font-semibold text-gray-900 text-sm">Günlük Gönderilen Mesajlar</h3>
            <p className="text-xs text-gray-400 mt-0.5">Son 7 gün</p>
          </div>
          <div className="w-7 h-7 flex items-center justify-center bg-emerald-50 rounded-lg">
            <i className="ri-bar-chart-2-line text-sm text-emerald-600"></i>
          </div>
        </div>
        <div className="flex items-end gap-2 h-24">
          {dailyMessageData.map((d, i) => {
            const height = Math.round((d.sayi / maxVal) * 100);
            const isToday = i === dailyMessageData.length - 1;
            return (
              <div key={i} className="flex-1 flex flex-col items-center gap-1.5">
                <div className="w-full flex items-end" style={{ height: "72px" }}>
                  <div
                    className={`w-full rounded-t-md transition-all duration-500 ${
                      isToday ? "bg-[#25D366]" : "bg-gray-200"
                    }`}
                    style={{ height: `${height}%` }}
                  />
                </div>
                <span className="text-[10px] text-gray-400">{d.gun}</span>
              </div>
            );
          })}
        </div>
      </div>

      {/* Donut-style */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5">
        <div className="flex items-center justify-between mb-5">
          <div>
            <h3 className="font-semibold text-gray-900 text-sm">Mesaj Durumu Dağılımı</h3>
            <p className="text-xs text-gray-400 mt-0.5">Toplam {totalStatus} mesaj</p>
          </div>
          <div className="w-7 h-7 flex items-center justify-center bg-sky-50 rounded-lg">
            <i className="ri-pie-chart-2-line text-sm text-sky-600"></i>
          </div>
        </div>
        <div className="space-y-3">
          {messageStatusData.map((d, i) => {
            const pct = Math.round((d.value / totalStatus) * 100);
            return (
              <div key={i}>
                <div className="flex items-center justify-between text-xs mb-1.5">
                  <div className="flex items-center gap-2">
                    <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ background: d.color }}></span>
                    <span className="text-gray-600">{d.label}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-gray-800">{d.value}</span>
                    <span className="text-gray-400">%{pct}</span>
                  </div>
                </div>
                <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full"
                    style={{ width: `${pct}%`, background: d.color }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}